import { createFileRoute } from '@tanstack/react-router';
import { CashRegisterPage } from '@/features/treasury/components/CashRegisterPage';

export const Route = createFileRoute('/$commiteeSlug/treasury/cash-register')({
  component: CashRegisterPage,
});
